import { Component } from "react"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"
import {
    BulkEmailNumberSentFilter,
    BulkEmailNumberOpensFilter,
    BulkEmailNumberClicksFilter,
    BulkEmailSentFromFilter,
    BulkEmailCreatedByFilter,
    BulkEmailDateFilter,
    BulkEmailSentDateAfterFilter,
    BulkEmailSentDateBeforeFilter,
    BulkEmailOfficialReceivedFilter,
    BulkEmailStafferReceivedFilter,
    BulkEmailPressContactReceivedFilter,
    BulkEmailSupporterReceivedFilter,
    BulkEmailOfficialOpenedFilter,
    BulkEmailStafferOpenedFilter,
    BulkEmailPressContactOpenedFilter,
    BulkEmailSupporterOpenedFilter,
    BulkEmailOfficialClickedFilter,
    BulkEmailStafferClickedFilter,
    BulkEmailPressContactClickedFilter,
    BulkEmailSupporterClickedFilter,
    BulkEmailProjectFilter,
} from "shared/search/containers/Filter/BulkEmailFilters"

export class BulkEmailProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "BulkEmailProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter results by the issue they are tagged to.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkEmailRecipientFilterGroup extends Component {
    static defaultProps = {
        filters: [
            BulkEmailOfficialReceivedFilter,
            BulkEmailStafferReceivedFilter,
            BulkEmailPressContactReceivedFilter,
            BulkEmailSupporterReceivedFilter,
            BulkEmailOfficialOpenedFilter,
            BulkEmailStafferOpenedFilter,
            BulkEmailPressContactOpenedFilter,
            BulkEmailSupporterOpenedFilter,
            BulkEmailOfficialClickedFilter,
            BulkEmailStafferClickedFilter,
            BulkEmailPressContactClickedFilter,
            BulkEmailSupporterClickedFilter,
        ],
        uniqueFilterGroupId: "BulkEmailRecipientFilterGroup",
        displayLabel: "Recipients",
        helpText:
            "Filter emails from the last 12 months by officials, press, and supporters who received, opened, or clicked the email",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkEmailDateFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkEmailDateFilter, BulkEmailSentDateAfterFilter, BulkEmailSentDateBeforeFilter],
        uniqueFilterGroupId: "BulkEmailDateFilterGroup",
        displayLabel: "Date",
        helpText: "Filter emails by the date they were sent.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkEmailParticipantsFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkEmailSentFromFilter, BulkEmailCreatedByFilter],
        uniqueFilterGroupId: "BulkEmailParticipantsFilterGroup",
        displayLabel: "Participants",
        helpText: "Filter emails by who sent or created the email",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkEmailStatisticsFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkEmailNumberSentFilter, BulkEmailNumberOpensFilter, BulkEmailNumberClicksFilter],
        uniqueFilterGroupId: "BulkEmailStatisticsFilterGroup",
        displayLabel: "Statistics",
        helpText: "Filter emails by the number of emails sent, opened or clicked",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
